/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { Random } from "random-js";
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const pageRef = con.eventDB.collection(cn).doc('CustomPageList').collection('Pages')
const storageRef = con.storageRef
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var userEventsRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection('UserEvents');


export default {
    fetchPages({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            pageRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    var docObj = doc.data();
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    markers.push(docObj)
                })
                commit('SET_PAGES', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })
        })
    },
    fetchPage(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                context.dispatch('generateNumber', 4).then(function(randomNumber){
                    resolve({
                        status: 200,
                        data: {
                            Title: '',
                            Slug: '',
                            IsPublished: true,
                            MetaTitle: '',
                            MetaDescription: '',
                            CdnURL: null,
                            designJson: null,
                            html: null,
                            randomNumber: randomNumber
                        }
                    })
                })
            } else {
                let docObj = new Object
                pageRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;       
                    resolve({
                        status: 200,
                        data: docObj
                    })             
                })
            }
        })
    },
    updatePage(context, field) {
        return new Promise(async(resolve, reject) => {
            let docObj = {
                    Title: field.data.Title,
                    IsPublished: field.data.IsPublished,
                    MetaTitle: field.data.MetaTitle,
                    MetaDescription: field.data.MetaDescription,
                    designJson: field.data.designJson,
                    html: field.data.html,
                    LastModifiedDate: new Date()
                }

            let url = await context.dispatch('uploadHTMLAsFiles', field.data);
            //docObj.CdnURL = url.CdnURL;
            //docObj.FbURL = url.FbURL;
            pageRef.doc(`${field.id}`).update(docObj).then(function() {                
                resolve({ status: 200, message: 'Data Updated.' })        
            }).catch(function(error) {
                //console.log('Error getting update attendee:', error)
                reject(error)
            })
        })
    },
    updateStatus(context, field){
        return new Promise((resolve, reject) => {
            pageRef.doc(`${field.id}`).update({IsPublished: field.IsPublished }).then(function(doc) {
                context.dispatch('fetchPages').then(res=> {
                    resolve({ status: 200, message: 'Data Updated.' })
                })                        
            }).catch(function(error) {
                //console.log('Error getting update attendee:', error)
                reject(error)
            })
        })
    },
    addPage(context, field) {
        //console.log(atob(field.id));
        //console.log(field); 
        //debugger    
        return new Promise(async(resolve, reject) => {
                //let pageId = "RT" + new Date().getTime();    
                    let docObj = {
                        Title: field.data.Title,
                        IsPublished: field.data.IsPublished,
                        Slug: field.data.Slug,
                        MetaTitle: field.data.MetaTitle,
                        MetaDescription: field.data.MetaDescription,
                        CdnURL: null,
                        FbURL: null,
                        designJson: field.data.designJson,
                        html: field.data.html,
                        CreatedDate: new Date(),
                        LastModifiedDate: new Date()
                    }

                    let url = await context.dispatch('uploadHTMLAsFiles', field.data);
                    docObj.CdnURL = url.cd;
                    docObj.FbURL = url.FbURL;
                    //context.dispatch('getAutoId').then(PageId => {                                            
                        pageRef.add(docObj).then(function(doc) {
                            //docObj.PageId = doc.id;                            
                            pageRef.doc(`${doc.id}`).update({PageId: doc.id}).then(async function() {                                
                                resolve({ status: 200, message: 'Data Added.', Id: doc.id })
                            })
                        }).catch(function(error) {
                            reject(error)
                        })
                    //});
                

        })
    },
    uploadHTMLAsFiles(context, dataObj){
        return new Promise((resolve, reject) => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(dataObj.html, 'text/html');
            // let images = doc.body.getElementsByTagName('img'); 
            // if(images){                
            //     let srcList = [];
            //     for(let img of images) {
            //         srcList.push(img.src);
            //     }
            //     console.log(srcList);                
            // }
            //resolve(true);            
            let metaTitle = document.createElement('meta');  
            metaTitle.setAttribute('property', 'og:title');  
            metaTitle.content = dataObj.MetaTitle ? dataObj.MetaTitle : '';              
            doc.getElementsByTagName('head')[0].appendChild(metaTitle);
            doc.getElementsByTagName('head')[0].appendChild(document.createTextNode("\n"));
            
            let metaDescription = document.createElement('meta');  
            metaDescription.setAttribute('property', 'og:description');  
            metaDescription.content = dataObj.MetaDescription ? dataObj.MetaDescription : '';  
            doc.getElementsByTagName('head')[0].appendChild(metaDescription);
            doc.getElementsByTagName('head')[0].appendChild(document.createTextNode("\n"));
            
            let htmlString = doc.getElementsByTagName('html')[0].innerHTML;
            storageRef.child(`${cn}/CustomPages/${dataObj.Slug}.html`).putString(htmlString).then(function (snapshot) {
                snapshot.ref.getDownloadURL().then(function(url) {
                    resolve({FbURL: url, CdnURL: `https://resources.e2m.live/${storageRef.bucket}/${cn}/CustomPages/${dataObj.Slug}.html`});
                });
            }).catch(err=>{console.log(err)});            
        });
    },
    async getAutoId(context) {
        //let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        let AutoId = await promise;
        AutoId = AutoId * 1000;
        return await AutoId.toString();
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
                let totallength = field.data.length;
                let count = 0;
                for (var i = 0; i < field.data.length; i++) {
                    let data = field.data[i]
                    pageRef.doc(`${data.PageId}`)
                        .update({ IsPublished: field.Status })
                        .then(function() {
                            count = count + 1;
                            if (totallength == count)
                                resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                        })
                }
            }) // end of promise
    },
    generateNumber(context, numberLength) {
        const random = new Random(); // uses the nativeMath engine
        const value = random.hex(numberLength);
        //const value = random.integer(100000, 999999);
        return value.toString();
    },
    removeRecord({ commit }, userId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/user-management/users/${userId}`)
                .then((response) => {
                    commit('REMOVE_RECORD', userId)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    }
}